(function (window) {
  'use strict';

  var STORAGE_KEY = 'isha_wishlist_v1';

  function readAll() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function writeAll(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
    try {
      window.dispatchEvent(new CustomEvent('isha:wishlist-changed', { detail: { handles: list } }));
    } catch (e) {}
  }

  var IshaWishlist = {
    STORAGE_KEY: STORAGE_KEY,
    getAll: readAll,
    has: function (handle) {
      return readAll().indexOf(handle) > -1;
    },
    add: function (handle) {
      var list = readAll();
      if (list.indexOf(handle) === -1) {
        list.push(handle);
        writeAll(list);
      }
      return true;
    },
    remove: function (handle) {
      var list = readAll().filter(function (h) { return h !== handle; });
      writeAll(list);
      return false;
    },
    toggle: function (handle) {
      return this.has(handle) ? (this.remove(handle), false) : (this.add(handle), true);
    },
    count: function () {
      return readAll().length;
    }
  };

  window.IshaWishlist = IshaWishlist;
})(window);
